import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../hooks/use-user';
import { UserType } from '../../../lib/interfaces/user';
import LearningSuitePage from './page';

const LearningSuiteWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (user.userType !== UserType.Internal) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="flex flex-col gap-5 h-full">
      <LearningSuitePage />
    </div>
  );
};

export default LearningSuiteWrapper;
